<template>
    <div class="container containerEtiqueta">
        <div v-if="content" class="row">
            <div class="no-print">
                <div v-if="isSafari" class="alert -yellow">
                    <svg class="ico">
                        <use xlink:href="/images/svg-symbols.svg#ico-alert-yellow"></use>
                    </svg>
                    <p>Usuário Safari: Antes de confirmar a impressão, desabilite a opção "Imprimir cabeçalhos e rodapés" na janela de impressão.</p>
                </div>
            </div>

            <div class="no-print buttons">
                <a class="btnConfirm" href="javascript:;" @click="print">Imprimir</a>
            </div>

            <div class="print-box">
                <div
                        v-if="orders_where_latam_cargo.length"
                        class="latamcargo-minutas"
                >
                    <div class="page-break"></div>
                    <div class="clearfix">
                        <template v-for="order in orders_where_latam_cargo">
                            <latam-minuta
                                :key="order.id"
                                :order="order"
                            ></latam-minuta>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LatamCargoMinuta from 'commons/js/components/print/LatamCargoMinuta.vue';
    import { printWebview } from 'commons/js/utils/webview';

    export default {
        components: {
            'latam-minuta': LatamCargoMinuta
        },

        props: {
            content: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                isSafari: false
            };
        },

        computed: {
            orders_where_latam_cargo: function() {
                return this.content.tags.filter(order => {
                    return order.service.company.id === 6;
                });
            }
        },

        created() {
            this.isSafari =
                /constructor/i.test(window.HTMLElement) ||
                (function(p) {
                    return p.toString() === '[object SafariRemoteNotification]';
                })(
                    !window['safari'] ||
                    (typeof safari !== 'undefined' && safari.pushNotification)
                );
        },

        methods: {
            print() {
                window.print();

                printWebview();
            }
        }
    };
</script>

<style lang="stylus" scoped>
.clearfix:before
.clearfix:after
  content ''
  display table
.clearfix
  zoom 1
  &:after
    clear both
.print-box
  padding 15px
  background white
  box-shadow 0 0 20px rgba(0, 0, 0, .5)
  margin-bottom 25px
@media (max-width: 600px)
  .print-box
    margin 10px
@media print
  html
  body
  .container
  .row
  .print-box
  [class^=col]
    padding 0 !important
    margin 0 !important
  .print-box
    box-shadow none
  .no-print
    display none
</style>
